/**
 * System Flags represent various system wide constants used on the API and FrontEnd
 */
const SYSTEM_FLAGS = {
  SHIPPING_REQUEST_STATUS: {
    AWAITING_PROCESSING: "AWAITING_PROCESSING",
    FAILED_PROCESSING: "FAILED_PROCESSING",
    PENDING_APPROVAL: "PENDING_APPROVAL",
    APPROVED: "APPROVED",
    DISAPPROVED: "DISAPPROVED",
    COMPLETED: "COMPLETED"
  },
  PORT_STATUS: {
    INCOMING: "INCOMING",
    DOCKED: "DOCKED",
    DEPARTURE: "DEPARTURE",
    DISPATCH_METHOD_TRUCK: "DISPATCH_METHOD_TRUCK",
    DISPATCH_METHOD_SHIP: "DISPATCH_METHOD_SHIP",
    DEPARTED: "DEPARTED"
  }
};

export default SYSTEM_FLAGS;
